export class EnvelopeDetailFilter {
    id: number;
    obfuscateMail: boolean;
    obfuscateSsn: boolean;
    obfuscatePhone: boolean;
    isDeleted: boolean;
}
